export const isUnique = (existingRecordsArr) => (input) => {
  return (
    !input || input === '' || !existingRecordsArr?.length || !existingRecordsArr.includes(input)
  )
}
